<template>
  <div class="dashboard-main-container">
    <main-header :show-logo="true" />
    <div class="dashboard-content">
      <router-view v-if="isImporter" />
    </div>
  </div>
</template>
<script>
import MainHeader from '@/components/MainHeader'

export default {
  computed: {
    isImporter() {
      return this.$store.state.account?.account?.role === 'importers'
    }
  },
  mounted() {
    if (this.$store.getters.user?.currentAccount?.role === 'exporters') {
      this.$router.push({ name: 'dashboard' })
    }
  },
  components: {
    MainHeader
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.dashboard-main-container {
  @media screen {
    height: 100vh;
    overflow: auto;
  }
  flex-grow: 1;
}

.dashboard-content {
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
  height: calc(100vh - 140px);
  padding-left: 30px;
  padding-right: 30px;
}
</style>
